// ============================================================
// FILE: src/components/PageHero.jsx  →  INNER PAGE HEADERS
// The big title block at the top of every inner page
// (About, Products, Services...) with breadcrumbs.
// ============================================================

import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { MaskedLine } from "./Reveal";

export default function PageHero({ label, title, accent, description, crumbs = [] }) {
  return (
    <section className="relative overflow-hidden pb-16 pt-40 sm:pb-20" data-testid="page-hero">
      <div className="bg-grid pointer-events-none absolute inset-0 opacity-60" />
      <div className="pointer-events-none absolute -top-40 left-1/2 h-[480px] w-[720px] -translate-x-1/2 rounded-full bg-blue-700/15 blur-[140px] dark:bg-blue-700/25" />
      <div className="pointer-events-none absolute -right-32 top-20 h-72 w-72 rounded-full bg-teal-500/10 blur-[100px]" />
      <div className="container-x relative">
        <nav className="mb-6 flex items-center gap-1.5 text-xs text-muted-foreground" data-testid="breadcrumbs">
          <Link to="/" className="transition-colors hover:text-teal-500">Home</Link>
          {crumbs.map((c, i) => (
            <span key={i} className="flex items-center gap-1.5">
              <ChevronRight className="h-3 w-3" />
              {c.to ? <Link to={c.to} className="transition-colors hover:text-teal-500">{c.label}</Link> : <span className="text-foreground/70">{c.label}</span>}
            </span>
          ))}
        </nav>
        <p className="section-label">{label}</p>
        <h1 className="mt-4 max-w-4xl font-display text-5xl font-bold leading-[1.05] tracking-tighter sm:text-6xl lg:text-7xl">
          <MaskedLine delay={0.1}>{title}</MaskedLine>
          {accent && <MaskedLine delay={0.22} className="text-gradient">{accent}</MaskedLine>}
        </h1>
        {description && (
          <MaskedLine delay={0.34}>
            <span className="mt-6 block max-w-2xl text-base leading-relaxed text-muted-foreground sm:text-lg">{description}</span>
          </MaskedLine>
        )}
      </div>
    </section>
  );
}
